import api from '@/libs/axios'
import axios from '@/libs/axios'
import cookie from '@/api/Csrf'
export default {
  namespaced: true,
  state: {
    userData: null,
    allUsersPages: ['dashboard'],
    pages: [],
    bookmarks: [],
    settings: {},
  },
  getters: {
    getAllowNotifications(state){
      return state.userData.settings.allowNotifications
    },
    getPreferLang(state) {
      if(state.userData!=null){
      return state.userData.settings.lang
      }else{
        return "ar";
      }
    },

    isPreferSkinDark(state) {
      if(state.userData!=null){
        //console.log( state.userData.settings.skin)
      return state.userData.settings.skin
      }else{
        return 'light';
      }
    },
    preferDirIsRtl(state) {
      if(state.userData!=null){
      return state.userData.settings.lang === 'ar'
      }else{
        return true;
      }
    },
    user(state) {
      return state.userData
    },

    role(state) {
      return state.userData.roles[0]
    },

    menus(state) {
      return [...state.userData?.permissions, ...state.allUsersPages]
    },

  },
  mutations: {
    setAllowNotifications(state,val){

      state.userData.settings.allowNotifications=val
    }
    
    ,
    SET_AUTH_DATA(state, val) {

      state.userData = val
    },

    SET_WDIGET_DATA(state,val){
      

      Object.assign(state.userData,{widgets:val})
    },

    SET_LANG(state,val){
     

      Object.assign(state.userData,{settings:{lang:val}})
    }

  },
  actions: {

    setAllowNotifications({ commit },allow){
      commit('setAllowNotifications',allow)
    },
    async get_me({ commit }) {
      try {
       // window.localStorage.clear()
        const response = await api.get('/user')
        commit('SET_AUTH_DATA', response.data)
      } catch (e) {
      
        //console.log(e)
        commit('SET_AUTH_DATA', null)
      }
    },
     

    signOut({commit}) {
      window.localStorage.clear()
    
      commit('SET_AUTH_DATA', null)
    },

    async bookmark({ commit }, bookmarks) {
      try { return  await axios.post('user/setBookmark', {bookmarks}) }
      catch (e){ console.log(e) }
    },

    async skin({ commit }, dark) {
      try { return  await axios.post('user/setMode', {dark}) }
      catch (e){ console.log(e) }
    },

    async lang({ commit }, lang) {
      try { return  await axios.post('user/setLang', {lang}) }
      catch (e){ console.log(e) }
    },

      restShowWidgets({commit},widget_array){

       commit('SET_WDIGET_DATA',widget_array)

      }
  },
}
